<!-- Busca inline de item da venda. Mesmo desenho do seletor de cliente do
     cabeçalho desta tela: p-autoComplete com os ícones (× e lupa) posicionados
     DENTRO do input. -->

<!-- Campo e contador de resultados na mesma linha (>= 769px), para o hint não
     gastar uma linha inteira do card. Abaixo disso o SCSS volta a empilhar. -->
<div class="vib-linha">
<div class="vib-wrapper">
  <!-- [autoOptionFocus] é OBRIGATÓRIO para o Enter funcionar sem setas: o
       `onEnterKey` do PrimeNG só seleciona com `focusedOptionIndex !== -1`.
       `[autoHighlight]` não serve — nesta versão é código morto.
       [delay]=0 porque a temporização é toda do RxJS (ver `debounce` no .ts).
       appendTo="body" evita que o painel seja recortado pelo card.

       [completeOnFocus] e [minLength]=0 fazem a LISTA PRÉVIA e são AMBOS
       necessários, para casos diferentes:
         - completeOnFocus cobre o FOCO: o `onInputFocus` chama
           `search(..., 'focus')`, e o minLength só se aplica à origem 'input'.
         - minLength=0 cobre o APAGAR: com minLength=2, esvaziar por backspace
           caía no `else` do `onInput` e dava `hide()` — a lista não voltava. -->
  <p-autoComplete
    [inputId]="inputId"
    [(ngModel)]="termo"
    [suggestions]="sugestoes"
    (completeMethod)="onBuscar($event)"
    (onSelect)="onSelecionar($event.value ?? $event)"
    (onClear)="onCampoLimpo()"
    optionLabel="nome"
    [minLength]="0"
    [delay]="0"
    [autoOptionFocus]="true"
    [forceSelection]="false"
    [completeOnFocus]="true"
    [showEmptyMessage]="true"
    [emptyMessage]="'contador_operar.venda.nenhum_item' | translate"
    [placeholder]="'contador_operar.venda.item_placeholder' | translate"
    [ariaLabel]="'contador_operar.venda.item_busca.campo_aria' | translate"
    [disabled]="disabled"
    styleClass="w-full"
    inputStyleClass="w-full vib-input"
    panelStyleClass="venda-item-busca-panel"
    scrollHeight="260px"
    appendTo="body">

    <!-- Linha da sugestão. O espaçamento vem do `gap` do flex, NUNCA de espaço
         entre tags: o projeto compila com `preserveWhitespaces: false` e o
         Angular remove esse espaço (causa histórica do "Coca Cola Zero402"). -->
    <ng-template let-produto pTemplate="item">
      <div class="ac-item">
        <span *ngIf="exibirCodigoDoItem && produto.codigoItem" class="ac-item-cod">#{{ produto.codigoItem }}</span>
        <span *ngIf="exibirCodigoDeBarras && produto.barras" class="ac-item-cod ac-item-barras">
          {{ produto.barras }}
        </span>
        <span class="ac-item-nome">{{ produto.nome }}</span>
        <span *ngIf="temPreco(produto)" class="ac-item-preco">
          {{ produto.precoDeVenda | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
        </span>
        <span *ngIf="!temPreco(produto)" class="ac-item-preco ac-item-sempreco">
          {{ 'contador_operar.venda.item_busca.sem_preco' | translate }}
        </span>
        <span *ngIf="produto.saldo != null" class="ac-item-saldo">
          {{ 'contador_operar.venda.item_busca.saldo' | translate: { saldo: produto.saldo } }}
        </span>
        <!-- ⛔ Não acrescentar um `+` aqui: o clique na linha já escolhe, e a
             faixa de lançamento tem o seu próprio botão. Dois `+` com
             significados diferentes (carregar na linha × lançar no carrinho)
             confundem. -->
      </div>
    </ng-template>

    <!-- Rodapé fixo do dropdown: escapatória para quem prefere a lista paginada.
         Fica preso no rodapé por construção (é irmão flex do <ul>, que é quem
         rola) — ver o SCSS deste componente. -->
    <ng-template pTemplate="footer">
      <div class="vib-footer">
        <div class="vib-footer-acao"
             role="button"
             tabindex="0"
             [attr.aria-label]="'contador_operar.venda.item_busca.abrir_lista_aria' | translate"
             (click)="onVerListaCompleta($event)"
             (keydown.enter)="onVerListaCompleta($event)">
          <i class="pi pi-search" aria-hidden="true"></i>
          <span>{{ 'contador_operar.venda.item_busca.ver_lista' | translate }}</span>
        </div>

        <!-- Cadastro rápido: abre o mesmo diálogo "Criar novo Item" usado em
             /adicionar-compra (app-item-criar-rapido). Só aparece quando o pai
             liga [permitirCriarItem] — /criar-pedido NÃO liga. -->
        <div *ngIf="permitirCriarItem"
             class="vib-footer-acao vib-footer-acao--criar"
             role="button"
             tabindex="0"
             [attr.aria-label]="'contador_operar.venda.item_busca.criar_item_aria' | translate"
             (click)="onCriarItem($event)"
             (keydown.enter)="onCriarItem($event)">
          <i class="pi pi-plus" aria-hidden="true"></i>
          <span>{{ 'contador_operar.venda.item_busca.criar_item' | translate }}</span>
        </div>
      </div>
    </ng-template>
  </p-autoComplete>

  <!-- Ícones dentro do input, alcançáveis por teclado (role + tabindex +
       Enter) — ícone clicável sem isso é lacuna de a11y. -->
  <div class="vib-icons">
    <i *ngIf="termo && !disabled"
       class="pi pi-times vib-icon-clear"
       role="button"
       tabindex="0"
       [attr.aria-label]="'contador_operar.venda.item_busca.limpar_aria' | translate"
       (click)="limparCampo()"
       (keydown.enter)="limparCampo()"></i>
    <i class="pi pi-search vib-icon-search"
       role="button"
       tabindex="0"
       [class.disabled]="disabled"
       [attr.aria-label]="'contador_operar.venda.item_busca.abrir_lista_aria' | translate"
       (click)="onAbrirLista()"
       (keydown.enter)="onAbrirLista()"></i>
  </div>
</div>

  <!-- ÚNICO role="status" do componente (o p-autoComplete já emite um interno).
       O SCSS reserva a altura: no modo empilhado, sem isso o card "pula" quando
       a mensagem aparece e some. -->
  <small class="vib-hint" role="status" aria-live="polite">
    <ng-container *ngIf="hint">{{ hint.chave | translate: hint.params }}</ng-container>
  </small>
</div>
